var themes = {
    page: function(){
        if($('#countryID').val() != 0){
            location.href = '/booking/theme/list/' + $('#countryID').val();
        }
    },
    list: function(page){
        var params = $('#themegroup-form').find('input, select').serializeObj();

        params.page = page || 1;

        var getParams = location.pathname+"?"+($.param(params));

        if(window.history && window.history.replaceState){
            window.history.replaceState(null, null, getParams);
            $.get(getParams, {},function(resp){
                $("#themegroup-list").html(resp)
            });
        }else{
            location.href=getParams;
        }
    },
    edit: function(themeID) {
        var themeID = themeID || 0,
            params = $('#themegroup-form').find('input, select').serializeObj();

        $.post('/booking/theme/edit/' + themeID, params, function(resp){
            popup(resp.html, resp.title).dialog();
        }, 'json');
    },
    save: function(themeID) {
        var
            themeID = themeID || 0,
            params = $('#themegroup-popup-form').find('input, select').serializeObj();

        $('#themegroup-popup-success i').toggle('fast')

        $.post('/booking/theme/save/' + themeID, params,function(){
            themes.list();
            closeLastPopup();
        }).fail(function(resp) {
            utils.error(resp.responseJSON, 'themegroup-popup-form');
            $('#themegroup-popup-success i').toggle('fast')
        });
    },
    update: function (themeID, paramname, paramvalue) {
        $.post('/booking/theme/update/' + themeID, {paramname:paramname,paramvalue:paramvalue});
    },
    deactivate: function(themeID) {
        var themeID = themeID || 0;

        $('#themegroup-popup-warning i').toggle('fast');

        $.post('/booking/theme/deactivate/' + themeID, {},function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
            $('#themegroup-popup-warning i').toggle('fast')
        });
    },

    activate: function(themeID) {
        var themeID = themeID || 0;

        $('#themegroup-popup-alert i').toggle('fast')

        $.post('/booking/theme/activate/' + themeID, {},function(){
            location.reload();
        }).fail(function(resp) {
            utils.error(resp.responseJSON);
            $('#themegroup-popup-alert i').toggle('fast')
        });
    },
};